/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { helper } from '@ember/component/helper';
import { typeOf } from '@ember/utils';

// imported and adapted from https://github.com/DockYard/ember-composable-helpers/blob/master/addon/helpers/queue.js , rather than just importing that dependency because it's not maintained

// todo: properly type this

export default helper(function queue(actions: any[] = []) {
  return function (...args: any[]) {
    const invokeWithArgs = function (action: any, curr: any) {
      if (isPromise(action)) {
        return action.then(() => curr(...args));
      }

      return curr(...args);
    };

    return actions.reduce((acc, curr, idx) => {
      if (idx === 0) {
        return curr(...args);
      }

      return invokeWithArgs(acc, curr);
    }, undefined);
  };
});

function isPromiseLike(obj: any = {}) {
  return typeOf(obj.then) === 'function' && typeOf(obj.catch) === 'function';
}

function isPromise(obj: any) {
  return isObject(obj) && isPromiseLike(obj);
}

function isObject(val: any) {
  return typeOf(val) === 'object' || typeOf(val) === 'instance';
}
